(() => {
  const PRIVACY_PATH = /^\/policies\/privacy-policy\/?$/i;

  const isExcluded = (node) => {
    const el = node.parentElement;
    if (!el) return true;
    return !!el.closest(
      'script, style, noscript, template, textarea, input, select, option, code, pre, [data-shopify-editor-section]'
    );
  };

  const replacePrivacyText = (value) => {
    let t = value;

    // Replace the common Shopify-generated sentence with vendor-neutral wording
    // while preserving the substantive disclosure that third-party commerce
    // infrastructure providers are involved.
    t = t.replace(
      /Elizna is powered by Shopify,\s*which enables us to provide the Services to you\.?/gi,
      'ELIZNA uses third-party commerce and technology service providers to operate and provide the Services.'
    );

    t = t.replace(
      /ELIZNA is powered by Shopify,\s*which enables us to provide the Services to you\.?/gi,
      'ELIZNA uses third-party commerce and technology service providers to operate and provide the Services.'
    );

    // Possessive form first.
    t = t.replace(/\bShopify['’]s\b/gi, "our commerce service provider's");

    // Remaining vendor-name references on the privacy page become a neutral,
    // functional description rather than disappearing entirely.
    t = t.replace(/\bShopify\b/gi, 'our commerce service provider');

    return t;
  };

  const replaceGeneralText = (value) => {
    let t = value;

    t = t.replace(
      /\blive\s+Shopify\s+price\s+and\s+availability\b/gi,
      'live price and availability'
    );

    t = t.replace(
      /\bShopify\s+price\s+and\s+availability\b/gi,
      'live price and availability'
    );

    t = t.replace(/\bPowered by Shopify\b/gi, '');
    t = t.replace(/\bpowered by Shopify\b/gi, '');

    // Customer-facing generic fallback. This is only for visible storefront copy.
    t = t.replace(/\bShopify['’]s\b/gi, "the commerce platform's");
    t = t.replace(/\bShopify\b/gi, 'the commerce platform');

    return t;
  };

  const processTextNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    if (isExcluded(node)) return;

    const original = node.nodeValue;
    if (!original || !/shopify/i.test(original)) return;

    const revised = PRIVACY_PATH.test(location.pathname)
      ? replacePrivacyText(original)
      : replaceGeneralText(original);

    if (revised !== original) {
      node.nodeValue = revised;
    }
  };

  const walk = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      processTextNode(root);
      return;
    }

    if (!(root instanceof Element || root instanceof Document || root instanceof DocumentFragment)) {
      return;
    }

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (!node.nodeValue || !/shopify/i.test(node.nodeValue)) {
            return NodeFilter.FILTER_REJECT;
          }
          return isExcluded(node)
            ? NodeFilter.FILTER_REJECT
            : NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(processTextNode);
  };

  const cleanPoweredBy = () => {
    document
      .querySelectorAll(
        '.powered-by-shopify, [class*="powered-by-shopify"], a[href*="shopify.com"][aria-label*="Shopify" i]'
      )
      .forEach((el) => {
        const text = (el.textContent || '').trim();
        if (/powered by shopify/i.test(text) || el.className?.toString().includes('powered-by-shopify')) {
          el.hidden = true;
          el.setAttribute('aria-hidden', 'true');
        }
      });
  };

  const init = () => {
    walk(document.body);
    cleanPoweredBy();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => walk(node));

        if (mutation.type === 'characterData') {
          processTextNode(mutation.target);
        }
      }

      cleanPoweredBy();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
